export default __webpack_public_path__ + "5c0e1c370e57b270fd48c59541b8242e.svg";